import { IUniConfig } from "../../uni-base-module"
import { $uniDebug } from "../uni-debug.module"

class SoloDebugDirective implements ng.IDirective {
  restrict = "A"
  priority = 999
  scope: {
    ifDev: "@"
  }

  constructor(private $log: ng.ILogService, private UniConfig: IUniConfig) {
    this.scope = {
      ifDev: "@"
    }
  }

  compile(element: JQLite, attrs: ng.IAttributes) {
    // this.$log.info("******** Compile solodebug", attrs.ifDev, element.html())

    // if (attrs.ifDev === "foo")
    //     this.$log.info("es fooo")

    if (!this.UniConfig.debug) element.empty()

    return this.link
  }

  link(scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, ctrls: ng.IController) {
    // $log.debug("Instanciando SoloDebugDirective", scope);

    // si llega hasta aquí, es que no se ha eliminado, este check no es necesario
    if (this.UniConfig.debug) {
      // this.$log.debug("Activando ifDev", element);
      // element.prop("title", scope.titleDev);
      element.addClass("small if-dev-ul if__dev")
    } else element.remove()
  }
}

$uniDebug.directive("ifDev", [
  "$log",
  "UniConfig",
  ($log, UniConfig) => new SoloDebugDirective($log, UniConfig)
])
